import { createAction, props } from '@ngrx/store';
import { Company } from '../_models/company';

// Action types
export const loadCompanies = createAction('[Company] Load Companies');
export const loadCompaniesSuccess = createAction(
  '[Company] Load Companies Success',
  props<{ companies: Company[] }>()
);
export const loadCompaniesFailure = createAction(
  '[Company] Load Companies Failure',
  props<{ error: any }>()
);

export const addCompany = createAction('[Company] Add Company', props<{ company: Company }>());
export const addCompanySuccess = createAction(
  '[Company] Add Company Success',
  props<{ company: Company }>()
);
export const addCompanyFailure = createAction(
  '[Company] Add Company Failure',
  props<{ error: any }>()
);

export const updateCompany = createAction(
  '[Company] Update Company',
  props<{ company: Company }>()
);
export const updateCompanySuccess = createAction(
  '[Company] Update Company Success',
  props<{ company: Company }>()
);
export const updateCompanyFailure = createAction(
  '[Company] Update Company Failure',
  props<{ error: any }>()
);

export const deleteCompany = createAction('[Company] Delete Company', props<{ id: number }>());
export const deleteCompanySuccess = createAction(
  '[Company] Delete Company Success',
  props<{ id: number }>()
);
export const deleteCompanyFailure = createAction(
  '[Company] Delete Company Failure',
  props<{ error: any }>()
);
